import script from "./commonFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonFooter.vue?vue&type=script&setup=true&lang=ts"

import "./commonFooter.vue?vue&type=style&index=0&id=0044de1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0044de1c"]])

export default __exports__